import mixpanel from 'mixpanel-browser';
import { setAttribution } from './attribution';

const isBrowser = typeof window !== 'undefined';

// ── Event name constants ────────────────────────────────────────────
export const EVENTS = {
  CTA_CLICKED: 'CTA Clicked',
  HERO_EMAIL_SUBMITTED: 'Hero Email Submitted',
  REGISTRATION_STARTED: 'Registration Started',
  REGISTRATION_COMPLETED: 'Registration Completed',
  REGISTRATION_FAILED: 'Registration Failed',
  TOOL_USED: 'Tool Used',
  TOOL_PRINTED: 'Tool Printed',
  TOOL_CLEARED: 'Tool Cleared',
  RESOURCE_DOWNLOADED: 'Resource Downloaded',
  EXTERNAL_LINK_CLICKED: 'External Link Clicked',
} as const;

// ── Core helpers ────────────────────────────────────────────────────
export function track(event: string, properties?: Record<string, any>) {
  if (!isBrowser) return;
  mixpanel.track(event, properties);
}

export function identify(email: string, traits?: Record<string, any>) {
  if (!isBrowser) return;
  mixpanel.identify(email);
  if (traits) mixpanel.people.set(traits);
}

export function setSuperProperties(props: Record<string, any>) {
  if (!isBrowser) return;
  mixpanel.register(props);
}

export function setSuperPropertiesOnce(props: Record<string, any>) {
  if (!isBrowser) return;
  mixpanel.register_once(props);
}

// ── CTA tracking helper ─────────────────────────────────────────────
export function trackCTAClick(attrs: {
  cta_text: string;
  cta_location: string;
}) {
  const pagePath = isBrowser ? window.location.pathname : '';

  track(EVENTS.CTA_CLICKED, {
    cta_text: attrs.cta_text,
    cta_location: attrs.cta_location,
    page_path: pagePath,
  });

  setAttribution({
    cta_text: attrs.cta_text,
    cta_location: attrs.cta_location,
    cta_page: pagePath,
  });
}
